import Swiper from 'swiper';
import { Navigation, Thumbs, Autoplay } from 'swiper/modules';

const CarouselHook = {
  mounted() {
    const itemsPerView = this.itemsPerView();
    const gap = this.gap();
    const hasNavigation = this.hasNavigation();
    const thumbsEl = this.thumbsEl();
    const swiperEl = this.swiperEl(this.el);
    const autoplay = this.autoplay();

    let opts = {
      init: false,
      modules: [],
      slidesPerView: 1,
      autoHeight: this.autoHeight(),
      breakpoints: {
        0: {
          slidesPerView: itemsPerView.xs,
          spaceBetween: gap.xs,
        },
        640: {
          slidesPerView: itemsPerView.sm,
          spaceBetween: gap.sm,
        },
        768: {
          slidesPerView: itemsPerView.md,
          spaceBetween: gap.md,
        },
        1024: {
          slidesPerView: itemsPerView.lg,
          spaceBetween: gap.lg,
        },
        1280: {
          slidesPerView: itemsPerView.lg,
          spaceBetween: gap.lg,
        },
      },
    };

    // Enable navigation
    if (hasNavigation) {
      opts.modules.push(Navigation);
      opts.navigation = {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      };
    }

    // Enable thumbs
    if (!!thumbsEl) {
      opts.modules.push(Thumbs);
      opts.watchSlidesProgress = true;
    }

    if (!!autoplay) {
      opts.modules.push(Autoplay);
      opts.autoplay = {
        delay: autoplay,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(swiperEl, opts);

    this.el.addEventListener('slideTo', (e) => {
      this.swiper.slideTo(e.detail.index, e.detail.speed);
    });

    // Trigger el `init` event when Swiper initialized
    this.swiper.on('init', () => {
      const event = new CustomEvent('init');
      this.el.dispatchEvent(event);
    });

    this.swiper.on('afterInit', () => {
      $(swiperEl)
        .find('[data-mfp-src]')
        .magnificPopup({
          type: 'image',
          gallery: {
            enabled: true,
          },
        });
    });

    // Thumbs slider can be initialized before of after current slider so we handle both
    if (thumbsEl) {
      if (thumbsEl.swiper) {
        // Swiper already initialized
        this.swiper.params.thumbs.swiper = thumbsEl.swiper;
        this.swiper.thumbs.init();

        this.swiper.update();
      } else {
        // Wait for an event
        thumbsEl.addEventListener('init', (e) => {
          const swiperEl = this.swiperEl(e.target);

          this.swiper.params.thumbs.swiper = swiperEl.swiper;
          this.swiper.thumbs.init();
          this.swiper.update();
        });
      }
    }

    // Use delayed initialization so we set all event handlers first.
    this.swiper.init();
  },

  updated() {
    this.swiper.update();
  },

  autoHeight() {
    return this.el.dataset.autoHeight !== undefined;
  },

  hasNavigation() {
    return this.el.dataset.navigation !== undefined;
  },

  itemsPerView() {
    return JSON.parse(this.el.dataset.itemsPerView);
  },

  gap() {
    return JSON.parse(this.el.dataset.gap);
  },

  autoplay() {
    return this.el.dataset.autoplay && parseInt(this.el.dataset.autoplay);
  },

  swiperEl(target) {
    return target.querySelector('.swiper');
  },

  thumbsEl() {
    return this.el.dataset.thumbs && document.querySelector(this.el.dataset.thumbs);
  },
};

export default CarouselHook;
